import React from 'react';

import { useGetTravelperkPayableDataQuery } from 'modules/integrations/hooks';
import { type PayableId } from 'modules/payable';
import { QuerySuspense } from 'src/core/common/components/QuerySuspense';

import { ViewTrip } from './ViewTrip';

type Props = {
  payableId: PayableId;
};

export const Receipt = (props: Props) => {
  const { payableId } = props;
  const travelperkPayableQuery = useGetTravelperkPayableDataQuery(payableId);

  return (
    <QuerySuspense
      queryState={travelperkPayableQuery}
      loading={null}
      fallback={() => null}
    >
      {({ url }) => <ViewTrip externalUrl={url} />}
    </QuerySuspense>
  );
};
